import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown-menu show" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_ctx.editable)
      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createElementVNode("button", {
            class: "dropdown-item",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {
          _ctx.onCatalogProductEditAction();
          _ctx.close();
        })
          }, _toDisplayString(_ctx.t('Edit')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("li", null, [
      _createElementVNode("button", {
        class: "dropdown-item",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => {
          _ctx.onCatalogProductCopyAction();
          _ctx.close();
        })
      }, _toDisplayString(_ctx.t('Copy')), 1)
    ]),
    (_ctx.editable)
      ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createElementVNode("button", {
            class: "dropdown-item",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {
          _ctx.onCatalogProductDeleteAction();
          _ctx.close();
        })
          }, _toDisplayString(_ctx.t('Delete')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}